module.exports = __webpack_public_path__ + "img/2021_2_16_alien_harvest.998dd798.jpg";